export default function access(
  initialState: { currentUser?: API.CurrentUser } | undefined,
) {
  const { currentUser } = initialState ?? {};

  const authObj = {
    admManage: false,
    // 单位管理员
    admUser: false,
    admUserAdd: false,
    admUserEdit: false,
    admUserRemove: false,
    admUserClearFail: false,

    // 权限角色
    admRole: false,
    admRoleAdd: false,
    admRoleEdit: false,
    admRoleRemove: false,

    // 系统字典
    sysDic: false,
    sysDicAdd: false,
    sysDicEdit: false,
    sysDicRemove: false,

    // 系统日志
    admUserLog: false,
    admUserLogRemove: false,

    // 权限资源
    admRight: false,
    admRightGetTree: false,
    admRightAdd: false,
    admRightEdit: false,
    admRightRemove: false,

    // 商品管理
    goodManage: true,
    good: true,
    goodAdd: true,
    goodEdit: true,
    goodRemove: true,

    // 订单管理
    orderManage: true,
    order: true,
    orderSend: true,
    orderApplySettle: true,
    orderExport: true,

    // 用户管理
    userManage: true,
    userList: true,
    userApply: true,
    userApplyAdd: true,

    // 商户管理
    shopManage: true,
    shopOperator: true,
    shopOperatorAdd: true,
    shopOperatorEdit: true,
    shopOperatorRemove: true,

    // 财务管理
    financial: true,
    userPay: true,
    userRefund: true,
    userButieLog: true,
  };

  // if (currentUser !== undefined) {
  //   const rights = currentUser?.right_keys ?? [];
  //   if (rights.includes("*")) {
  //     Object.keys(authObj).forEach((key) => {
  //       // @ts-expect-error
  //       authObj[key] = true;
  //     });
  //   } else {
  //     Object.keys(authObj).forEach((key) => {
  //       // @ts-expect-error
  //       authObj[key] = rights.includes(key) || false;
  //     });
  //   }
  // }

  return {
    ...authObj,
  };
}
